import { render, staticRenderFns } from "./PurchaseOrderResource.vue?vue&type=template&id=3043916c&"
import script from "./PurchaseOrderResource.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports